import { Moment } from 'moment';

import { RoomViewModel } from '@api/index';
import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';

import RoomSelectionCard from '../room-selection/RoomSelectionCard';
import { SelectedVariationProps } from '../../context/types';
import { getHandleSelectedVariationParams, getRoomCardProps } from './helpers';

export interface RoomOptionDetailProps {
  room: RoomViewModel;
  hotelId: number;
  startDate: Moment;
  endDate: Moment;
  hotelRoomList: ListingSearchRoomInterface[];
  nightCount: number;
  selectedTab: number;
  hotelName: string;
  countryCode?: string;
  isExpedia: boolean;
  openDatePicker: () => void;
  selectedVariations: SelectedVariationProps[];
  handleSelectVariation: (variation: SelectedVariationProps) => void;
  onSelectDates?(): void;
}

const RoomOptionDetails = ({
  room,
  hotelId,
  isExpedia,
  hotelName,
  countryCode,
  openDatePicker,
  nightCount,
  startDate,
  endDate,
  hotelRoomList,
  selectedTab,
  selectedVariations,
  handleSelectVariation,
}: RoomOptionDetailProps) => {
  return (
    <>
      {nightCount ? (
        room?.details?.map((detail) =>
          detail.informations
            .filter((inf) => inf.requestedRoomIndex === selectedTab)
            .map((information) =>
              information.variations.length ? (
                information.variations.map((variation) => (
                  <RoomSelectionCard
                    {...getRoomCardProps({
                      information,
                      detail,
                      selectedVariations,
                      variation,
                      hotelId,
                      hotelName,
                      hotelRoomList,
                      startDate,
                      endDate,
                      isExpedia,
                      selectedTab,
                      nightCount,
                    })}
                    countryCode={countryCode}
                    openDatePicker={openDatePicker}
                    onSelectVariation={() =>
                      variation.totalDiscountedSellingPrice
                        ? handleSelectVariation(
                            getHandleSelectedVariationParams({
                              information,
                              variation,
                              selectedTab,
                              detail,
                              roomId: room.id,
                              roomProvider: room.provider,
                            })
                          )
                        : undefined
                    }
                    key={variation.id}
                    isRefundable={detail?.isRefundable}
                    cancellationPolicyDetails={
                      detail?.roomInfo?.cancellationPolicyDetails
                    }
                  />
                ))
              ) : (
                <RoomSelectionCard
                  title={detail.roomInfo?.boardType}
                  status={information.availabilityStatus}
                  alertMessage={information.availabilityMessage}
                  id={hotelId}
                  hotelName={hotelName}
                  countryCode={countryCode}
                  formCheckInDate={startDate}
                  formCheckOutDate={endDate}
                  hotelRoomList={hotelRoomList}
                  openDatePicker={openDatePicker}
                  isRefundable={detail?.isRefundable}
                  cancellationPolicyDetails={
                    detail?.roomInfo?.cancellationPolicyDetails
                  }
                />
              )
            )
        )
      ) : (
        <RoomSelectionCard
          id={hotelId}
          warningText='Fiyatları görmek için tarih seçiniz'
          openDatePicker={openDatePicker}
        />
      )}
    </>
  );
};

export default RoomOptionDetails;
